import './Clipper.scss';

export const initClipper = (node = document) => {
  const clippers = node.querySelectorAll('[data-clipper]');
  [].forEach.call(clippers, (clipper) => {
    clipper.addEventListener('click', () => {
      const items = node.querySelectorAll(`[data-clipper-for="${clipper.dataset.clipper}"]`);
      [].forEach.call(items, (item) => item.classList.add('-visible'));
      clipper.classList.add('hidden');
    });
  });
};

initClipper();
